module.exports = __webpack_public_path__ + "assets/img/204cc065be999c2d22710f2a61682649.png";